import React, { FC } from 'react'

type Props = {
  width?: string | number
  height?: string | number
  className?: string
  color?: string
}

const SortArrows: FC<Props> = (props) => {
  const { width = 18, height = 18, className = '', color = '#309BEC' } = props

  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15V3M5 3L1.8 6.2M5 3L8.2 6.2"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3V15M13 15L9.8 11.8M13 15L16.2 11.8"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SortArrows
